export enum ProfileTab
{
    HEADLINES = "headlines",
    REALIZATIONS = "realizations",
}

export interface ProfileHeadlines
{
    id: number;
    headline: string;
    created_at: Date;
}
